import React, { useEffect, useMemo } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { Col, Button, Row } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import validate from './validateApi';
import { partial } from '../../../util/translation/translation';
import renderSelectField from '../../../shared/components/form/Select';
import renderSwitchField from '../../../shared/components/custom/Switch';
import TooltipWithIcon from '../../../shared/components/custom/TooltipWithIcon.jsx';

const NewsProviderForm = ({
  handleSubmit,
  categories,
  initialize,
  providerData,
}) => {
  const s = partial('shared');
  const p = partial('NewsForm');
  const categoryOptions = useMemo(
    () =>
      [...categories, { name: s('notSelected') }].map((item) => ({
        label: item.name,
        value: item.id,
      })),
    // s is a new function reference every render (partial() isn't memoized);
    // including it would recompute categoryOptions every render, which in
    // turn re-triggers the initialize effect below on every render.
    // eslint-disable-next-line
    [categories]
  );
  useEffect(() => {
    const currentCategory = providerData?.category?.id;
    initialize({
      category: categoryOptions.find(
        (item) => item.value === currentCategory
      ) || { label: s('notSelected') },
      pushEnabled: providerData?.pushEnabled,
    });
    // initialize is a stable redux-form dispatch and s is redefined every
    // render; depending on them would re-run this effect on every render.
    // eslint-disable-next-line
  }, [providerData, categoryOptions]);
  return (
    <form onSubmit={handleSubmit} className="form">
      <Col>
        <Row>
          <div className="form__form-group">
            <span className="form-header">{s('newsCategory')}</span>
            <Field
              name="category"
              placeholder={s('newsCategory')}
              options={categoryOptions}
              component={renderSelectField}
            />
          </div>
        </Row>
        <Row>
          <span className="form">
            {s('sendPushNotification')}
            &nbsp;
            <TooltipWithIcon
              id="external-link-tooltip"
              text={p('pushEnabledDescription')}
            />
          </span>
          <div className="form__form-group-field">
            <Field
              name="pushEnabled"
              component={renderSwitchField}
              label={[`${p('pushEnabled')}`, `${p('pushDisabled')}`]}
              className="colored-click"
            />
          </div>
        </Row>
      </Col>
      <Col md={12}>
        <Button type="submit" color="primary">
          {s('create')}
        </Button>
        <Link className="color-unset" to="/news?tab=2">
          <Button type="button">{s('close')}</Button>
        </Link>
      </Col>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'news_provider_form',
  validate,
});

export default withRouter(
  connect((state) => ({
    formValues: getFormValues('news_provider_form')(state),
  }))(reduxF(NewsProviderForm))
);
